export const general = {
	main: {
		main: 'Home',
		quests: 'Quests',
		enter: 'Login',
		register: 'Registration',
		begin: 'Start',
		take: 'Claim',
		begin_quest: 'Start the quest',
		rockets_try_another_filters: 'Try different filter settings or go to the Hero section on the Parik24 website',
		product_filter: 'Filters',
		loading: 'Page loading...',
		reset_filters: 'Reset',
		readMoreBtn: 'More details',
		back: 'Back',
		next: 'Next',
		bonus_shop: 'Bonus shop',
		all: 'All',
		status: 'Status',
		buy_history: 'Purchase history',
		points: 'Points',
		points_p: 'points',
		common: 'Common',
		rare: 'Rare',
		epic: 'Epic',
		legendary: 'Legendary',
		to_increase: 'Ascending',
		to_decrease: 'Descending',
		tournament: 'Tournament',
		tournaments: 'Tournaments',
		nothing_here: "There's nothing here yet",
		try_another_filters_no_brand: 'Try different filter settings',
		account: 'Account number',
		phone: 'Phone',
		password: 'Password',
		to_enter: 'Enter',
		buy: 'Buy',
		close: 'Close',
		congratulations: 'Congratulations!',
		delivered: 'Delivered',
		send: 'Sent',
		cancel: 'Cancel',
		shop: 'Shop',
		sections: 'Sections',
		apply: 'Apply',
		reset_all: 'Reset all',
		clear: 'Ok',
		more: 'More',
		nomadHomeTitle: 'Магазин Бонусов NOMAD приветствует вас!',
		promotions: 'Promotions',
		promotion: 'Promotion',
		current_plural: 'Current',
		left_to_start: 'Time left until start',
		prizes: 'Prizes',
		total: 'Total',
		promotion_history: 'Promotion history',
		tickets: 'Tickets',
		date: 'Date',
		active_status: 'Active',
		ended_status: 'Ended',
		pending_status: 'Pending',
		results: 'Results',
		place: 'Place',
		doBetsNomad: 'Bet with NOMAD',
		filters: 'Filters',
		sort_by: 'Sort by:',
		categories: 'Categories',
		go_to_tournament: 'Go to tournament',
		faq: 'FAQ',
		participant: 'Participant',
		participants: 'Participants',
		prize: 'Prize',
		pmPoints: 'PM points',
		pmPointsPlural: 'PM points',
		winners: 'Winners',
		winners_dec: 'Winners',
		receive_prize: 'Claim prize',
		email: 'E-mail',
		info: 'Information',
		shop_new: 'NEW',
		shop_hot: 'HOT',
		details: 'Details',
		credited: 'Credited',
		cancel_reason: 'Reason for cancellation',
		out_of_stock: 'Out of stock',
		duration: 'duration',
		leaders: 'Leaders',
		refresh: 'Refresh',
		loading_common: 'Loading',
		join: 'Join',
		starting_soon: 'Soon',
		before_start: 'Before start:',
		before_finish: 'Before finish:',
		bonuses: 'Bonuses',
		jackpot: 'Jackpot',
		filter: 'Filter',
		footer_offer: 'Promotion Terms and Conditions',
		help: 'Help',
		profile: 'Profile',
		attach_trade_link: 'Attach your Steam trade link',
		link: 'Link',
		attach_steam: 'Link your Steam account.',
		xp_points: 'XP points',
		attach: 'Attach',

		//Date Plurals
		seconds_plur_one: '{{prefix}}second{{suffix}}',
		seconds_plur_few: '{{prefix}}seconds{{suffix}}',
		seconds_plur_many: '{{prefix}}seconds{{suffix}}',
		seconds_plur_other: '{{prefix}}seconds{{suffix}}',

		minutes_plur_one: '{{prefix}}minute{{suffix}}',
		minutes_plur_few: '{{prefix}}minutes{{suffix}}',
		minutes_plur_many: '{{prefix}}minutes{{suffix}}',
		minutes_plur_other: '{{prefix}}minutes{{suffix}}',

		hours_plur_one: '{{prefix}}hour{{suffix}}',
		hours_plur_few: '{{prefix}}hours{{suffix}}',
		hours_plur_many: '{{prefix}}hours{{suffix}}',
		hours_plur_other: '{{prefix}}hours{{suffix}}',

		days_plur_one: '{{prefix}}day{{suffix}}',
		days_plur_few: '{{prefix}}days{{suffix}}',
		days_plur_many: '{{prefix}}days{{suffix}}',
		days_plur_other: '{{prefix}}days{{suffix}}',

		weeks_plur_one: '{{prefix}}week{{suffix}}',
		weeks_plur_few: '{{prefix}}weeks{{suffix}}',
		weeks_plur_many: '{{prefix}}weeks{{suffix}}',
		weeks_plur_other: '{{prefix}}weeks{{suffix}}',

		months_plur_one: '{{prefix}}month{{suffix}}',
		months_plur_few: '{{prefix}}months{{suffix}}',
		months_plur_many: '{{prefix}}months{{suffix}}',
		months_plur_other: '{{prefix}}months{{suffix}}',

		years_plur_one: '{{prefix}}year{{suffix}}',
		years_plur_few: '{{prefix}}years{{suffix}}',
		years_plur_many: '{{prefix}}years{{suffix}}',
		years_plur_other: '{{prefix}}years{{suffix}}',

		second_short: 's',
		minute_short: 'm',
		hour_short: 'h',
		day_short: 'd',
		week_short: 'w',
		month_short: 'mo',
		year_short: 'y',

		//Other Plurals
		points_plur_one: '{{prefix}}point{{suffix}}',
		points_plur_few: '{{prefix}}points{{suffix}}',
		points_plur_many: '{{prefix}}points{{suffix}}',
		points_plur_other: '{{prefix}}points{{suffix}}',

		// Gender forms
		finished_m: 'Finished',
		finished_f: 'Finished',
		finished_n: 'Finished',
		finished_p: 'Finished',

		in_progress_m: 'In progress',
		in_progress_f: 'In progress',
		in_progress_n: 'In progress',
		in_progress_p: 'In progress',

		condition_rules_vippass: `Terms and Conditions of the VIP House Pass Promotion`,

		days: {
			singular: 'day',
			pair: 'days',
			plural: 'days',
			short: 'd'
		},
		weeks: {
			singular: 'week',
			pair: 'weeks',
			plural: 'weeks',
			short: 'w'
		},
		hours: {
			singular: 'hour',
			pair: 'hours',
			plural: 'hours',
			short: 'h'
		},
		minutes: {
			singular: 'minute',
			pair: 'minutes',
			plural: 'minutes',
			short: 'm'
		},
		seconds: {
			singular: 'second',
			pair: 'seconds',
			plural: 'seconds',
			short: 's'
		}
	},
	coin_race: {
		title: 'Coin Race',
		description: 'A competition between players. Collect the most {{points}} during the race and win valuable prizes',
		jackpot_info: {
			title: 'Jackpot',
			description: 'Jackpot is added as a multiplier from points earned by participants',
			description2: 'The more points you and other participants earn, the bigger the jackpot will be',
			description3: 'Your points will remain with you, nothing will be deducted',
			description4: 'The jackpot is divided between winners according to the race rules'
		},
		error: {
			races: 'Failed to load coin races. Please refresh the page or try again later.'
		},
		info: {
			points: {
				title: 'Points',
				description: 'Points are counted toward the race score'
			},
			duration: {
				title: 'Duration',
				description: 'Races may vary in duration'
			},
			participation: {
				title: 'Participation',
				description: 'To start participating, click “Join”'
			},
			prizes: {
				title: 'Prizes',
				description: 'Prizes can be fixed or jackpot-based'
			}
		},
		filters: {
			title: 'Sort by time until finish:',
			my_races: 'My races',
			races: 'Races'
		},
		emptyState: {
			active: 'No active races',
			pending: 'No upcoming races',
			completed: 'No completed races'
		}
	},
	coin_race_details: {
		prize: 'Prize',
		place: 'Place',
		points: 'Points',
		finished: 'Race finished',
		time_left_label: 'TIME LEFT UNTIL RACE ENDS:',
		rules_title: 'Participation rules',
		prizes_coming_soon: 'Prizes coming soon',
		leave_action: 'Leave race',
		no_participants: 'No participants yet',
		modals: {
			join_success: 'You have successfully joined the race <strong>"{{raceName}}"</strong>',
			leave_confirmation: 'Are you sure you want to leave the tournament? All points will be cancelled.'
		}
	},
	promo: {
		title1: 'Earn',
		title1_hg: 'points with {{brandName}}',
		title2: 'Complete',
		title2_hg: 'quests',
		patch1: 'Verify your account',
		patch2: 'Top up your balance',
		patch3: 'Place an accumulator bet',
		quests: 'Quests'
	},
	promoJohnny: {
		title1: 'Earn',
		title1_hg: 'points with Johnny 24',
		title2: 'Complete',
		title2_hg: 'quests',
		patch1: 'Verify your account',
		patch2: 'Top up your balance',
		patch3: 'Place an accumulator bet',
		quests: 'Quests'
	},
	promogroup: {
		title: 'Exchange points',
		title_hg: 'for rewards',
		pic1_name: 'Freebet worth 5000 KZT',
		pic2_name: 'CS 2',
		pic3_name: 'Dota 2',
		pic4_name: 'Lootbox',
		pic_prize: '846,000 PM points',
		desc_title: 'More rewards',
		desc_title_hg: 'inside',
		shop: 'Shop'
	},
	promogroupXp: {
		desc_title: 'MORE REWARDS',
		desc_title_hg: 'INSIDE',
		shop: 'Shop'
	},
	prefooter: {
		title: 'Starter',
		title_hg: 'Boost',
		desc1: 'Get',
		desc1_hg: '300 PM points',
		desc1_end: 'at the start!',
		desc2: 'Exchange your',
		desc2_hg: 'starter boost',
		na: 'for',
		desc1_end_hg: 'a lootbox'
	},
	prefooterXp: {
		title: 'YOUR FIRST',
		title_hg: 'REWARD',
		desc1: 'Get',
		desc1_hg: '{{points}} XP',
		desc1_end: 'for linking your Steam account',
		desc2: '',
		desc2_hg: '',
		na: '',
		desc1_end_hg: ''
	},
	banner: {
		title: 'Farm with Parimatch',
		subtitle: 'Complete quests, earn GG points and exchange them for awesome rewards',
		btn: 'Farm Rewards',
		title1: 'Complete',
		title1_hg: 'quests',
		title2: 'Earn',
		title2_hg: 'points',
		title3_hg: 'skins',
		title3: 'Exchange for',
		title3_suffix: 'and skins',
		button: 'Start',
		home: `LOOT REWARDS <span>WITH {{name}}</span> <br /> Earn XP points by completing <span>quests and exchange them for awesome rewards</span>`
	},
	rules: {
		title: 'How it works',
		connect: 'Connect your accounts',
		register: 'Register or sign in to your Parimatch account and link your Steam account',
		quests: 'Complete quests',
		finish:
			'Complete quests in PM Hero on the Parimatch website to receive reward chests. For completing tasks, you will also earn GG points on the PM Pass website.',
		chest: 'Open chests',
		bonuses: 'Chests contain Parimatch bonuses and other rewards. The harder the quest, the more valuable the loot!',
		store: 'Rewards Shop',
		change: 'Collect GG points and exchange them for bonuses and other awesome rewards on the PM Pass website.'
	},
	prizes: {
		title: 'Rewards for every taste',
		text1:
			'PM Hero and PM Pass are your source of endless rewards. Earn prizes and GG points for every completed quest on the Parimatch website.',
		text2:
			'Spend your points on whatever you like in the PM Pass shop: CS2 skins, Dota 2 items, freebets, merch, and much more. The choice is yours!'
	},
	quests: {
		text1:
			'Complete quests by placing sports bets or playing Dota 2 via Steam. To view the full list of tasks, visit the Parimatch website and find the PM Hero section.',
		text2: 'Quests are updated daily — farm rewards endlessly!'
	},
	activity_history: {
		title: 'Purchase History',
		date: 'Date',
		item: 'Item',
		amount: 'Cost in points',
		status: 'Status'
	},
	faq: {
		faq_top: 'Frequently Asked Questions',

		question1: 'How do I link my Parik-24 and Steam accounts?',
		answer1_text1: 'Make sure your Dota 2 privacy settings allow your match history to be visible.',
		answer1_text2:
			'You must also be a registered user on the website or in the app <a class="green" href="https://parik-24.io/" target="_blank">parik.io</a>.',
		answer1_text3:
			'If you are not registered yet, follow this link <a class="green" href="https://parik-24.io/regmail/" target="_blank">https://parik-24.io/regmail</a> and create a Parik-24 account.',
		answer1_text4:
			'Then click the “Participate” button on this page. Enter your ID and password used during registration.',
		answer1_text5:
			'You can copy your ID in the “My Account” section – <a class="green" href="https://parik-24.io/uk/my-account" target="_blank">https://parik-24.io/uk/my-account</a>.',

		question2: 'Why should I link my Steam account?',
		answer2:
			'Quests can be completed not only on the Parik-24 website but also in Dota 2. By linking your Steam account, you can enjoy your favorite game and earn rewards for it!',

		question3: 'Can I participate without a Steam account?',
		answer3_text1:
			'Yes, you can participate by completing quests not related to Dota 2. In this case, you only need a Parik-24 account.',
		answer3_text2: 'Go to the gamification section and start playing right now.',

		question4: 'How can I participate?',
		answer4_text1: 'To participate:',
		answer4_text2: 'Be registered on Parik-24;',
		answer4_text3: 'Log in;',
		answer4_text4: 'Complete quests daily and earn guaranteed points;',
		answer4_text5: 'Exchange points for items in the shop;',

		question5: 'Who can participate?',
		answer5: 'Only individuals who have reached the age of 21 at the start of the promotion may participate.',

		question6: 'How do I open my Steam inventory to receive items?',
		answer6_text1: 'To receive items from the Shop, your inventory must be set to public.',
		answer6_text2: 'To do this:',
		answer6_text3: 'Open the Steam client;',
		answer6_text4: 'Hover over your login in the top-right corner and select “Inventory” from the dropdown menu;',
		answer6_text5: 'Click on the “More” tab and select “Privacy Settings”;',
		answer6_text6: 'Select “Public” in the “Profile Status” and “Inventory” sections;',
		answer6_text7: 'Click “Save Changes”.',

		question7: 'Why can’t I make a purchase in the shop?',
		answer7_text1: 'This may be due to one of the following reasons:',
		answer7_text2: 'No trade link in your profile: Make sure your trade link is added and up to date.',
		answer7_text3: 'Steam inventory is private: Open your inventory in Steam privacy settings.',
		answer7_text4: 'Hourly purchase limit exceeded: Please wait and try again later.',
		answer7_text5: 'Insufficient points balance: Check if you have enough points for the purchase.',
		answer7_text6: 'Make sure your Steam account does not have a trade ban.',
		answer7_text7:
			'If all of the above have been checked and the issue persists, please contact our support team for further assistance.',

		question8: 'Issue with trade link.',
		answer8_text1: 'This may be due to one of the following reasons:',
		answer8_text2: 'No trade link in your profile.',
		answer8_text3: 'The trade link does not match your Steam trade link.',
		answer8_text4: 'A trade lock occurred due to adding/removing the Steam authenticator. Learn why.',
		answer8_text5:
			'If all of the above have been checked and the issue persists, please contact our support team for additional help.'
	},
	faq_johnny: {
		faq_top: 'Frequently Asked Questions',

		question1: 'How do I link my Johnny24 and Steam accounts?',
		answer1_text1:
			'Click the “Loot Rewards” button and enter your Johnny24 ID/phone/email and the password you used during registration. You can copy your ID in the “My Account” section.',

		question2: 'Can I participate without a Steam account?',
		answer2:
			'Yes, to complete quests you only need a Johnny24 account if you do not plan to exchange XP for in-game rewards (skins, items, etc.). Go to the <a class="link" href="https://ngu3-sender.com/gamification/" target="_blank">Bonus League</a> section and start playing right now.',

		question3: 'How do I open my Steam inventory to receive items?',
		answer3_text1: 'To receive in-game items and skins purchased with XP points, your inventory must be set to public.',
		answer3_text2: 'To do this:',
		answer3_text3: 'Open the Steam client;',
		answer3_text4: 'Hover over your login in the top-right corner and select “Inventory” from the dropdown menu;',
		answer3_text5: 'Click the “More” tab and choose “Privacy Settings”;',
		answer3_text8: 'Select “Public” in the “Profile Status” and “Inventory” sections;',
		answer3_text9: 'Click “Save Changes”.',

		question4: 'How can I check my quest progress?',
		answer4_text1:
			'You can track your progress on the <a class="link" href="https://ngu3-sender.com/gamification/" target="_blank">quests page</a>. Quest progress is usually updated within 10–20 minutes.',

		question5: 'How much time do I have to complete quests and claim rewards?',
		answer5:
			'Quests are updated every 3–4 days and have a set completion time (see quest details for more information). This is an ongoing promotion, so you can accumulate points on your balance and exchange them for your desired rewards in the shop.',

		question6: 'How do I earn points and rewards?',
		answer6_text1:
			'Each completed quest grants a certain amount of XP points. To credit them to your balance, click “Claim Reward” on the quest page. You can use accumulated points to exchange them for rewards in the shop. All shop rewards can be claimed once every 24 hours. The number of rewards is limited.',

		question7: 'Why can’t I make a purchase in the shop?',
		answer7_text1: 'This may be due to one of the following reasons:',
		answer7_text2: 'No trade link in your profile: Make sure your trade link is added and up to date.',
		answer7_text3: 'Steam inventory is private: Open your inventory in Steam privacy settings.',
		answer7_text4: 'Daily purchase limit exceeded: Please wait and try again later.',
		answer7_text5: 'Insufficient XP balance: Check if you have enough points for the purchase.',
		answer7_text6:
			'Make sure your Steam account does not have a trade ban. -> <a target="_blank" href="https://help.steampowered.com/ru/faqs/view/451E-96B3-D194-50FC">Go to page</a>',
		answer7_text7: 'If all of the above have been checked and the issue persists, please contact our support team.',

		question8: 'Issue with trade link.',
		answer8_text1: 'This may be due to one of the following reasons:',
		answer8_text2: 'No trade link in your profile.',
		answer8_text3: 'The trade link does not match your Steam trade link.',
		answer8_text4:
			'A trade lock occurred due to adding/removing the Steam authenticator. Learn why. -> <a target="_blank" href="https://help.steampowered.com/ru/faqs/view/7EFD-3CAE-64D3-1C31">Go to page</a>',
		answer8_text5:
			'If all of the above have been checked and the issue persists, please contact our support team for additional assistance.',

		question9: 'Support',
		answer9_text1:
			'If you did not find the answer to your question above, please contact us via live chat on the website -> <a class="link" href="https://24johnny.com/uk/support" target="_blank">Go to page</a>'
	},
	faq_vippass: {
		faq_top: 'Frequently Asked Questions',
		questionMoney: 'Currency Equivalents',
		answerQuestionMoney:
			'All amounts are in USD and calculated using the following exchange rate: 1 USD = 1 EUR / 40 UAH',
		question1: 'How do I link my Vip House and Steam accounts?',
		answer1_text1:
			'Click the “Loot Rewards” button and enter your ID/phone/email and the password used during registration. You can copy your ID in the <a class="link" href="https://com2-sender.com/uk/my-account" target="_blank">“My Account”</a> section.',

		question2: 'Can I participate without a Steam account?',
		answer2:
			'Yes, to complete quests you only need a Vip House account if you do not plan to exchange XP for in-game rewards (skins, items, etc.). Go to the <a class="link" href="https://com2-sender.com/uk/gamification/profile" target="_blank">Bonus League</a> section and start playing right now.',

		question3: 'How do I open my Steam inventory to receive items?',
		answer3_text1: 'To receive in-game items and skins purchased with XP points, your inventory must be set to public.',
		answer3_text2: 'To do this:',
		answer3_text3: 'Open the Steam client;',
		answer3_text4: 'Hover over your login in the top-right corner and select “Inventory” from the dropdown menu;',
		answer3_text5: 'Click the “More” tab and choose “Privacy Settings”;',
		answer3_text8: 'Select “Public” in the “Profile Status” and “Inventory” sections;',
		answer3_text9: 'Click “Save Changes”.',

		question4: 'How can I check my quest progress?',
		answer4_text1:
			'You can track your progress on the <a class="link" href="https://com2-sender.com/uk/gamification/" target="_blank">quests page</a>. Progress is usually updated within 10–20 minutes.',

		question5: 'How much time do I have to complete quests and claim rewards?',
		answer5:
			'Quests are updated every 3–4 days and have a set completion time (see quest details for more information). This is an ongoing promotion, so you can accumulate points on your balance and exchange them for your desired rewards in the shop.',

		question6: 'How do I earn points and rewards?',
		answer6_text1:
			'Each completed quest grants a certain amount of XP points. To credit them to your balance, click “Claim Reward” on the quest page. Points can be used to exchange for rewards in the shop. All shop rewards can be claimed once every 24 hours. The number of rewards is limited.',

		question7: 'Why can’t I make a purchase in the shop?',
		answer7_text1: 'This may be due to one of the following reasons:',
		answer7_text2: 'No trade link in your profile: Make sure your trade link is added and up to date.',
		answer7_text3: 'Steam inventory is private: Open your inventory in Steam privacy settings.',
		answer7_text4: 'Daily purchase limit exceeded: Please wait and try again later.',
		answer7_text5: 'Insufficient XP balance: Check if you have enough points for the purchase.',
		answer7_text6:
			'Make sure your Steam account does not have a trade ban. -> <a target="_blank" href="https://help.steampowered.com/ru/faqs/view/451E-96B3-D194-50FC">Go to page</a>',
		answer7_text7: 'If all of the above have been checked and the issue persists, please contact our support team.',

		question8: 'Issue with trade link.',
		answer8_text1: 'This may be due to one of the following reasons:',
		answer8_text2: 'No trade link in your profile.',
		answer8_text3: 'The trade link does not match your Steam trade link.',
		answer8_text4:
			'A trade lock occurred due to adding/removing the Steam authenticator. Learn why. -> <a target="_blank" href="https://help.steampowered.com/ru/faqs/view/7EFD-3CAE-64D3-1C31">Go to page</a>',
		answer8_text5:
			'If all of the above have been checked and the issue persists, please contact our support team for additional assistance.',

		question9: 'Support',
		answer9_text1:
			'If you did not find the answer above, please contact us via live chat on the website -> <a class="link" href="https://viphouse35.com/uk/support" target="_blank">Go to page</a>',

		question10: 'How long can XP remain on my balance?',
		answer10_text1:
			'Accumulated XP points should be used before the end of the current season (spring, summer, autumn, winter). Every 3 months, XP balances are automatically reset to ensure fair conditions for all players. So don’t wait — exchange your points now and collect even more XP and rewards in the next season!'
	},
	profile: {
		title: 'Profile',
		info: 'Account Information',
		received_points: 'Points Earned',
		current_balance: 'Current Balance',

		dota_history_closed: 'Match history is private, please check your settings.',
		go_to_settings: 'Open Dota 2 and go to the Settings section.',
		in_chapter: 'In the Community section, find Public Match History, click on it to make your history visible.',

		match_history: 'Match History',
		match_history_closed: 'Match history is private, please check your settings.',
		go_to_dota2: 'Open Dota 2 and go to the Settings section.',
		go_to_community: 'In the Community section, find Public Match History and enable it.',

		history_open: 'Your match history is public.',
		steam_attached: 'Your Steam trade link is attached.',
		steam_is_not_attached: 'Your Steam account is not linked.'
	},
	welcome: {
		intro_title: '- your gateway to a world of awesome rewards',
		intro_text1: 'This is the official product of Parimatch.',
		intro_text2:
			'Complete tasks and earn bonus points, exchange them for freebets, CS2 and Dota 2 skins, loot boxes, and other items in the shop.',

		shop_and_quests_shop: 'Quests and ',
		shop_and_quests_quests: 'Shop',
		shop_and_quests_text1: 'It’s simple. Keep track of available tasks on the Quests page.',
		shop_and_quests_text2:
			'Each task shows how many PM points you will receive. After completion, your points will be credited to your pm-pass profile.',
		shop_and_quests_text3: 'You can exchange them on the Shop page.',

		quest_guide: 'You are one step away from',
		quest_guide_hg: 'awesome rewards',

		obj_one_title: 'Earn points with Parimatch',
		obj_one_desc: 'PM Points can be earned by completing quests and collecting sticker books.',

		obj_two_title: 'Your first quest',
		obj_two_desc: 'Complete verification and receive a 2000 KZT freebet and 300 PM PASS points.',

		trade_link_text1: 'Attach your Steam trade link to receive skins and in-game items in the PM Pass shop.',
		ngu3_trade_link_text1: 'Attach your Steam trade link to receive skins and in-game items in the X-Pass shop.',
		com2_trade_link_text1: 'Attach your Steam trade link to receive skins and in-game items in the Vip House shop.',

		trade_link_text2: 'How do I get the link?',

		steam_text: 'To complete quests in Dota 2, you need to link your Steam account.',
		skip_step: 'You can skip this step and attach the link later.',

		steps: 'Steps:',
		steps_one: '1. Go to parimatch.kz',
		steps_two: '2. Log in using the phone number you registered with.',
		steps_three: '3. Open your profile and go to the “Account Verification” section.',

		rockets_intro1: 'Boost up with ',
		rockets_intro1_description:
			'Spend your points on anything you like in the Bonus Shop: free spins, freebets, sports and casino cash bonuses, and much more. The choice is yours!',
		rockets_intro_button: 'Load up with rewards',

		rockets_intro2: 'Collect rewards',
		rockets_intro2_description:
			'Quests grant Parik24 bonuses and other rewards. The harder the quest, the more valuable the loot!'
	},
	reg: {
		more_than_21: 'I am over 18 years old and agree',
		accept_offer: ' to the terms of the public offer and the terms of use',
		activate_bonus: 'Activate bonus on the first deposit',
		bonus_offer: 'Bonus offer terms',
		have_account: 'Already have an account?',
		no_account: 'Don’t have an account yet?',
		by_accepting_reg: 'By registering or logging in, you agree to the',
		rules_terms: 'Promotion Terms and Conditions',
		to_login: 'Log In',
		register: 'Registration',

		// Временный вариант пока не дадут условия потом заменить на more_than_21 и поправить в компоненте где выводится
		more_than_21_com2: 'I am over 18 years old'
	},
	help: {
		have_trouble: 'If you experience login issues or have other questions, please contact support.',
		ask_help: 'Try reaching out to customer support.',
		find_trade_link: 'To find your Steam trade URL, follow these steps:',
		find_nickname: 'Hover over your nickname to open the profile menu;',
		go_to: 'Go to Inventory;',
		click_button: 'Click the “Trade Offers” button;',
		open: 'Open “Who can send me Trade Offers?”;',
		trade_text1: 'In the “Third-Party Sites” section, you will find the “Trade URL” field.',
		down_here: 'Your Steam trade link is located at the bottom of this page.'
	},
	errors: {
		loginError: 'It looks like the entered details are incorrect or you do not have an account yet.',
		min_6_symbols: 'Minimum 6 characters.',
		min_1_number: 'At least 1 number (0–9).',
		number_registered: 'This phone number is already registered.',
		not_supported: 'This phone number is not supported.',
		error_data: 'Data processing error.',
		no_account: 'It looks like the entered details are incorrect or you do not have an account yet.',
		cancel_reason: 'Cancellation reason.',

		bad_params: 'Unable to purchase the item due to technical reasons. Please contact support for more information.',
		failed: 'Unable to purchase the item due to technical reasons. Please contact support for more information.',

		bad_buyer:
			'Unable to purchase the item due to issues with your Steam account (e.g., private inventory, trade lock after authenticator changes, too many declined offers). Please check your Steam settings and refer to the <a class="link" href=\'/faq/#question3\'>FAQ</a> for more details.',

		tradelink_outdated_error:
			'Trade link error. The trade link may be incorrect or a trade lock may have occurred after disabling the authenticator. Please verify your trade link and refer to the <a class="link" href=\'/faq/#question8\'>FAQ</a> for more information.',

		tradelink_format_error: 'Trade link error. Please make sure your trade link is correct.',

		escrow_restriction_error:
			'Trade lock error caused by re-linking the authenticator. Please check your Steam settings and refer to the FAQ for more information.',

		private_inventory_error:
			'Your Steam inventory is private. Please make it public and refer to the <a class="link" href=\'/faq/#question3\'>FAQ</a> for more details.',

		steam_trade_ban_error:
			'Your Steam account has a trade ban. Please check your account and refer to the <a class="link" href=\'/faq/#question3\'>FAQ</a> for more information.',

		tradelink_error:
			'An unknown trade link error occurred. Please visit the <a class="link" href=\'/faq/#question3\'>FAQ</a> for possible trade link issues.',

		buyer_has_buy_items_ban:
			'Your ability to purchase items has been temporarily blocked due to 7 cancelled trade offers within 1 hour. The restriction lasts 12 hours.',

		cancelled: 'You did not accept or declined the last trade offer. Please do not decline trade offers.',
		offer_expired: 'You did not accept the last trade offer.',
		offer_declined: 'You declined the last trade offer.',

		user_reached_limit_24h: 'Unfortunately, your daily limit has been exceeded.',
		user_has_shop_disabled: 'Technical maintenance is in progress. Exchange is currently unavailable.',
		user_has_no_steam_trade_url: 'Please add your Steam trade link in your Profile.',
		shop_item_not_published: 'This item is no longer available for purchase.',
		user_has_not_enough_pm_points: 'You do not have enough PM points for the exchange.',
		user_has_not_enough_points: 'You do not have enough points for the exchange.',
		user_reached_limit_per_user: 'Purchase limit per user has been exceeded.',
		items_in_stock_reached_limit: 'This item is out of stock.',

		rea_bonus_callback_error: 'Bonus processing error. Please contact support.',
		lottery_is_expired: 'The lottery participation period has expired.',
		shop_item_is_not_lottery: 'This item is not a lottery ticket.',
		bad_item_params_error: 'Invalid item parameters.',

		default: 'Unable to purchase the item due to technical reasons. Please contact support for more information.',

		user_has_not_enough_blitz_points: 'You do not have enough Crown Coins to exchange',
		present_send_bonus_blitz: 'Freebet is ready. Hurry up to activate!',
		present_send_blitz: 'Purchased!'
	},
	notifications: {
		steam_attached: 'Steam account linked',
		dota_history_opened: 'Match history is open',
		trade_link_attached: 'Trade URL attached',
		trade_link_edited: 'Trade URL updated',
		steam_edited: 'Steam account changed',
		present_send: 'The gift is already in Steam. Hurry up to claim it!',
		present_send_bonus: 'Freebet уже в Parimatch. Спешите активировать!',
		rockets_present_send_bonus: 'Freebet is already in Parik24. Hurry up to activate it!',
		present_send_merch:
			'Congratulations on your purchase! Please contact customer service to provide your shipping information.',
		present_applied: 'Congratulations on your purchase!',
		not_enough_cash: 'You don’t have enough PM points to trade',
		points_not_enough_cash: 'You don’t have enough points to trade',
		add_trade_link: 'Add your Steam trade URL to your Profile ',
		technical_issues: 'Technical maintenance in progress. Trading is unavailable.',
		account_copied: 'Account ID copied',
		steam_copied: 'Steam ID copied',
		wrong_trade_link: 'Invalid trade URL format',
		present_send_bonus_blitz: 'Freebet is ready. Hurry up to activate!',
		present_send_blitz: 'Purchased!'
	},
	cybermarathon: {
		main_title: 'Jump into the Spring <br /> Cyber Marathon <br /> with Parimatch',

		mission_first_title: 'Take part in quests',
		mission_first_description:
			'6 esports tournaments = 6 unique challenges. Complete all quests and compete for the Grand Prize!',

		mission_second_title: 'Complete tasks',
		mission_second_description:
			'By participating and achieving goals in quests, you earn PM points and tournament progress.',

		mission_third_title: 'Receive rewards',
		mission_third_description: 'Each completed quest brings you rewards and a chance to compete for top-tier prizes.',

		tournaments_title: 'Tournaments',
		superprizes_title: 'Super Prizes',
		rules_title: 'Rules',

		rules_item_title: 'The key is to stay in the race',
		rules_item_description: 'We will raffle prizes for completed quests and a super prize at the end of the season.',

		rules_item_title_2: 'Join quests and loot rewards',
		rules_item_description_2: 'Register and place bets on esports.',
		rules_item_description_3:
			'To complete a quest, you need a turnover of 5000 KZT, and you will automatically participate in the Cyber Marathon.',

		rules_item_title_3: 'Complete all quests and compete for the super prize',
		rules_item_description_4:
			'For each completed quest, you will receive a guaranteed 500 PM points. The more quests you complete, the higher your chances of winning super prizes.',

		rules_item_title_4: 'Earn PM points and exchange them for bonuses and skins',
		rules_item_description_5:
			'Additionally, you will get X unlimited quests that allow you to earn points throughout the season. Just place esports bets.',

		superprize_title: 'Compete for the Super Prize',
		superprize_description:
			'At the end of the season, we will raffle a high-end gaming PC packed with top-tier hardware and full peripheral setup.',

		another_title: 'Other Prizes',
		another_description: 'Prize draw will take place at the end of the season.',

		another_item_title: 'Prize for 5 quests',
		another_item_description: 'ASUS TUF Gaming F15 Laptop',

		another_item_title_2: 'Prize for 4 quests',
		another_item_description_2: 'Sony PlayStation 5 Pro',

		superprize_proccessor: 'Processor: Core i9 14900KF',
		superprize_motherboard: 'Motherboard: MSI MAG B760 TOMAHAWK WIFI',
		superprize_cooler: 'Cooling: PC Cooler DS360 BK (Liquid Cooling)',
		superprize_ram: 'RAM: Kingston Fury Beast 32GB (DDR5, 6000 MHz)',
		superprize_video_card: 'Graphics Card: Gigabyte RTX 5080 AERO OC SFF (16GB)',
		superprize_drive: 'Storage: Corsair MP600 PRO LPX (2TB, M.2 PCIe 4.0)',
		superprize_power_supply: 'Power Supply: Seasonic Focus GX-1000 (1000W, 80 Plus Gold)',
		superprize_case: 'Case: Antec CS ARGB 7210',

		superprize_title_2: 'Top-Tier Gaming Setup',
		superprize_description_2: 'Specifications'
	},
	shop: {
		closingText:
			'The store is open until the end of the month — make sure to use your points. We’re preparing something new just for you!',
		notAvailable: 'The shop is currently unavailable — please wait for updates on the website.'
	},
	offer: {
		akciya: '1. Promotion',
		organizator: '2. Organizer',
		member: '3. Participant',
		login_offer: '4. Login',
		mobile_app: '5. Mobile Application',
		prize_offer: '6. Prize',
		offer_header: 'PM Pass Promotion Rules',
		quest_offer: '7. Quest',
		rules_offer: '8. Rules',
		location_offer: '9. Location of the Promotion',
		deadline_offer: '10. Promotion Period',
		territoroy_offer: '11. Territory of the Promotion',
		promo_site: '12. Promo Website',
		verify_offer: '13. Verification',
		web_site: '14. Website',
		main_rules: '15. Main Rules',
		pm_points: '16. PM Point',
		freebet_offer: '17. FreeBet',

		main_terms: '1. General Provisions',
		main_terms_2: '2. Participation Terms.',
		main_terms_3: '3. Prizes.',
		main_terms_4: '4. Final Provisions.',

		p1: 'PM Pass is a unique indefinite promotion in which you can choose your own prize.',
		p2: 'Complete quests in PM Hero, earn PM points and exchange them for loot boxes, cases and other guaranteed prizes on the Promo Website.',
		p3: 'Main terms and definitions:',
		p4: '“PM Pass” promotion organized and conducted by the Organizer.',
		p5: 'Limited Liability Partnership “Bookmaker Company “PM Bet”, BIN 161240020520, a legal entity registered in accordance with the legislation of the Republic of Kazakhstan, located at: Republic of Kazakhstan, Almaty Region, Konaev city, Almatinskaya street, building 6/2, premise 2, postal code 040800.',
		p6: 'A person meeting clauses 1.2–1.4 of the Promotion Rules and participating in the Promotion.',
		p7: 'Participant’s gaming internet account registered on the Website or in the Mobile Application.',
		p8: 'The official mobile application of the Organizer parimatch.kz for iOS and Android operating systems.',
		p9: 'Prize in the Promotion. Types, quantity, conditions and deadlines for receiving Prizes are determined in accordance with Section 3 of the Rules.',
		p10: 'A task posted on the Promo Website and PM Hero platform, successful completion of which grants the Participant the right to receive a Prize.',
		p11: 'Official Promotion Rules published on the Promo Website.',
		p12: 'The Promotion is held on the Website and in the Mobile Application.',
		p13: 'From May 12, 2024 and conducted indefinitely until the Organizer announces its termination.',
		p14: 'Republic of Kazakhstan.',
		p15: 'Process of verification and/or confirmation of the Participant’s personal data.',
		p16: 'Rules for accepting bets and conducting wagers by the Organizer, published on the Website.',
		p17: 'A unit received in accordance with the Rules.',
		p18: 'A non-divisible amount of funds credited by the Organizer to the Login, not combined with other funds and constituting one type of Prize. In case of winning a bet placed using a FreeBet, the Participant receives only the winnings amount excluding the stake amount. The amount, conditions and validity period of FreeBet are determined by the Rules.',
		p19: 'The Rules define the procedure, terms, conditions of the Promotion, number of Prizes, and the procedure and place of their receipt.',
		p20: 'Only legally capable individuals who have reached the age of 21 at the time of the Promotion, are citizens of the Republic of Kazakhstan permanently residing in Kazakhstan, possessing a valid identity document, registered on the Website or in the Mobile Application and correctly filled in personal data on the Login are eligible to participate.',
		p21: 'If a Participant does not meet the requirements of clause 1.2 of the Rules, they shall be excluded from participation.',
		p22: 'Employees and representatives of the Organizer, affiliated persons and their close relatives, representatives of third parties having contractual or other legal relations with the Organizer, stateless persons, citizens of other countries and persons restricted from gambling participation are not allowed to participate.',
		p23: 'The Promotion is not a lottery within the meaning of the Law of the Republic of Kazakhstan “On Lotteries and Lottery Activities” and is a promotional campaign aimed at attracting new customers and maintaining interest in the Organizer’s services.',
		p24: 'The Organizer reserves the right to amend the Rules and exclude any Prize from the Promotion at any time without prior notice. Information about changes is published on the Promo Website and/or Website. The Organizer may terminate the Promotion at any time with at least 7 calendar days’ notice.',
		p25: 'By participating, the Participant confirms full agreement with the Rules and undertakes to comply with them.',
		p26: 'To participate, during the Promotion period the Participant must:',
		p27: 'Complete authorization on the Website or Mobile Application, fill in required fields, visit the Promo Website and create a PM Hero profile if none exists;',
		p28: 'Register in Steam (store.steampowered.com), link a Steam trade URL via the Promo Website and make the inventory public;',
		p29: 'Complete available Quests; bets must be settled before the end of the Quest period.',
		p30: 'For each completed Quest, the Participant receives PM points which can be exchanged for Prizes.',
		p31: 'FreeBet received as a Prize must be used within three days after it appears in the personal account.',
		p32: 'System bets, CashOut bets or bets settled after Quest completion do not participate. In accumulators, the total odds are considered.',
		p33: 'FreeBet bets are not counted toward Quest completion.',
		p34: 'The prize fund is formed from the Organizer’s funds.',
		p35: 'With sufficient PM points, Participants may receive loot boxes, cases, FreeBet and other guaranteed Prizes. Contents may vary according to Steam platform rules at activation.',
		p36: 'The Organizer may change the list and number of Prizes and required PM points without notice. The current list is published on the Promo Website.',
		p37: 'If a Prize involves Steam items, it must be activated within 30 minutes of receipt.',
		p38: 'By participating, the Participant consents to collection, processing and use of personal data for marketing and other purposes, including publication of name and image without compensation.',
		p39: 'The Participant may withdraw consent by written notice to the Organizer’s address.',
		p40: 'Upon withdrawal, personal data processing ceases in accordance with Kazakhstan law.',
		p41: 'The Organizer is not responsible for failure to perform actions due to deletion of personal data.',
		p42: 'The Organizer may unilaterally change the Promotion conditions at any time.',
		p43: 'The Promotion is available only for one gaming account per person, household, computer or IP address.',
		p44: 'The Organizer reserves the right to cancel any Prize and refuse issuance if unfair strategies are suspected (multi-accounting, arbitrage, incorrect odds, etc.).',
		p45: 'The Organizer may exclude any Participant without explanation.',
		p46: 'Claims are accepted within 60 days from the occurrence of the issue.'
	},
	// 	reg_offer_rules: в Украинском переводе есть только русский и для региона КЗ
	// bonus_reg_rules: в Украинском переводе есть только русский и для региона КЗ
	rockets_faq: {
		question1: 'How to participate?',
		question2: 'Who can participate?',
		answer1_text1: 'To participate:',
		answer1_text2: 'Log in and go to the Hero page;',
		answer1_text3: 'Click the «Participate» button to confirm your participation;',
		answer1_text4: 'Complete quests every day and receive guaranteed bonuses and points;',
		answer1_text5: 'Collect points and climb the player rankings;',
		answer1_text6: 'The higher the bet amount, the higher the ranking and better the prizes.',
		answer2_text1: 'Only individuals who are 18 years or older at the start of the promotion can participate.'
	},
	rockets_welcome: {
		welcome_title: 'Charge up with ',
		welcome_text: 'Complete quests, earn points, and exchange them for awesome prizes',
		welcome_button: 'Charge up with prizes',
		how_this_works: 'How it works',
		case1: 'Connect your account',
		case2: 'Complete quests',
		case3: 'Collect rewards',
		case4: 'Bonus shop',
		case5: 'Prizes for every taste',
		answer1: 'Sign up or log in to your Parik24 account',
		answer2:
			'Complete quests in the Hero section on the Parik24 website and get awesome bonuses. For completing quests, you will also earn points for the Bonus shop section.',
		answer3:
			'Quests bring you bonuses from Parik24 and other rewards. The harder the quest, the more valuable the loot!',
		answer4: 'Accumulate points and exchange them for bonuses and other awesome prizes on the Bonus shop page.',
		answer5_1:
			'Hero and Bonus shop are your source of endless prizes. Get rewards and points for every quest you complete on the Parik24 website.',
		answer5_2:
			'Spend your points on whatever you like in the Bonus shop: free spins, freebets, cash bonuses for sports and casino, and much more. The choice is yours!',
		answer5_3:
			'Complete quests by placing sports bets and playing casino games. To see the full list of tasks, go to the Parik24 website and find the Hero section.',
		answer5_4: 'Quests обновляются daily — charge up with prizes endlessly!',
		promotions: {
			promotions: 'Promotions',
			chip_new: 'New',
			chip_started: 'Started',
			chip_participating: 'Participate',
			tickets_buy: 'Buy tickets',
			to_promo_start: 'Time until it starts',
			to_promo_end: 'Time until the promotion ends',
			GuideTitle: 'How to participate',
			GuideCardTitle1: 'Participate',
			GuideCardTitle2: 'Buy tickets',
			GuideCardTitle3: 'Check results',
			GuideCardDescription1: 'Join the draw in just a few seconds!',
			GuideCardDescription2: 'Go to the shop and buy tickets to participate in the promotion',
			GuideCardDescription3: 'You will be able to track the promotion results in your personal account',
			participants_amount: 'Number of participants',
			look_participants: 'View participants',
			participants_table: 'Participants table',
			noParticipantsYet: 'No one is participating yet!',
			showMore: 'Show more',
			tickets: 'Tickets',
			ticketsAmount: 'Number of tickets',
			FaqCardTitle1: 'Where can I see the draw results?',
			FaqCardTitle2: 'Does the number of tickets affect my chance of winning?',
			FaqCardTitle3: 'When will the results be announced?',
			FaqCardDescription1:
				'All results are available in your personal account and on the lottery page itself — drop in and check whether you made the winners list!',
			FaqCardDescription2:
				'Yes! The more tickets you have, the higher your chances of winning. Each ticket is an additional chance to become a winner.',
			FaqCardDescription3:
				'The date and time of the results are shown on the promotion page. Don’t forget to check it — everything is transparent and right on schedule!',
			WinCongrats: 'Congratulations on your win!',
			YouWinIn: 'Congratulations on winning in',
			ContactSupport: 'For more details, please contact support.',
			WinnersList: 'Winners list'
		}
	},

	sk2Welcome: {
		title1: 'Charge up with Topmatch',
		title2: 'Collect rewards',
		text1:
			'Use your points to buy anything you like in the Bonus shop: FreeBets, Free Spins, money bonuses on sports and casino and much more. The choice is yours!',
		text2:
			'Quests give bonuses from Topmatch and other rewards. The more difficult the quest, the more valuable the loot!',
		button_text: 'Charged with bonuses'
	},

	promotions: {
		promotions: 'Promotions',
		chip_new: 'New',
		chip_started: 'Started',
		chip_participating: 'Participating',
		tickets_buy: 'Buy tickets',
		to_promo_start: 'Time left until the start',
		to_promo_end: 'Time left until the end of the promotion',
		GuideTitle: 'How to participate',
		GuideCardTitle1: 'Get involved',
		GuideCardTitle2: 'Buy tickets',
		GuideCardTitle3: 'Check the results',
		GuideCardDescription1: 'Take part and join the promotion in seconds!',
		GuideCardDescription2: 'Go to the store and purchase tickets to participate in the promotion.',
		GuideCardDescription3: 'You can track the results of the promotion in your personal account.',
		participants: 'Participants',
		participants_amount: 'Number of participants',
		look_participants: 'View participants',
		participants_table: 'Participants table',
		noParticipantsYet: 'No one is participating yet!',
		showMore: 'Show more',
		tickets: 'Tickets',
		ticketsAmount: 'Number of tickets',
		FaqCardTitle1: 'Where can I see the results of the promotion?',
		FaqCardTitle2: 'Does the number of tickets affect the chance of winning?',
		FaqCardTitle3: 'When will the results be known?',
		FaqCardDescription1: `All results are available in your personal account and on the lottery page itself—check in and see if you're on the winners' list!`,
		FaqCardDescription2:
			'Yes! The more tickets you have, the higher your chance of winning. Each ticket is an additional chance to become a winner.',
		FaqCardDescription3: `The date and time for the results are listed on the promotion page. Don't forget to check it out—everything is transparent and on schedule!`,
		WinCongrats: 'Congratulations on your victory!',
		YouWinIn: 'Congratulations on your victory in',
		ContactSupport: 'For more information, please contact support.',
		WinnersList: 'List of winners'
	},
	blitzWelcome: {
		title1: 'New Possibilities: Buy Bonuses & Win Top Prizes',
		title2: 'Earn Crown Coins for your glory!',
		title3: 'Daily gifts from the Royal Treasury!',
		text1: `In the Royal Bonus Shop, your Crown Coins are the key to untold riches.</br>
        Redeem majestic rewards worthy of a true ruler—Free Spins,
        Free Bets, Deposit Bonuses, Money Bonuses, and other Royal
        Rewards await your command.`,
		text2: `Rule the reels without limits—every spin brings you closer to your fortune.</br>
        Complete Royal Quests to claim extra coins, and rise through the
        ranks.</br>
        With each level you conquer, a chest of extra Crown Coins will be
        yours.`,
		text3: `
        Step into the kingdom each day and open the gates of the Bonus
        Calendar. </br>
        From Free Spins to Deposit Bonuses, from XP to Coins—every
        sunrise brings a new royal gift.
      `
	}
};
